module.exports = __webpack_public_path__ + "static/media/Sectoral_Thematic.a0c7fdc1.svg";